import Vue from 'vue';
import store from '@/store/store';
import localStorageHelper from '../helpers/local-storage-helper';
import { getVoiceLang } from '../helpers/locale-helper';
import formatFieldHelper from '../helpers/format-field-helper';
import layoutService from '../providers/layoutService';

let synth = null;
export let textSpeech = null;
let voiceList = [];

class TextToSpeech {
    constructor() {
        // console.log('constructor textToSpeech')
        try {
            synth = window.speechSynthesis;
            if (synth) {
                voiceList = synth.getVoices();
                textSpeech = new window.SpeechSynthesisUtterance();
                textSpeech.onend = () => {
                    this.onCancel();
                };
            }
        } catch (error) {
            console.log(error);
        }
    }

    changeRateSpeech() {
        switch (store.state.AppActiveUser.rateTextSpeech) {
            case 1:
                this.updateRateTextSpeech(1.5);
                break;
            case 1.5:
                this.updateRateTextSpeech(2.0);
                break;
            default:
                this.updateRateTextSpeech(1.0);
                break;
        }

    }

    updateRateTextSpeech(val) {
        localStorageHelper.updateRateTextSpeech(val);
        if (store.state.isAuthenticated) {
            layoutService.saveLayout({ rateTextSpeech: val }, new URLSearchParams());
        }
    }
    getTextToSpeech(reportDetail) {
        if (!store.state.isDesktop) return;
        if (
            reportDetail.content.title ||
            reportDetail.content.abstract ||
            reportDetail.content.text
        ) {
            return formatFieldHelper.removeDuplicateItem([
                reportDetail.content.title.data,
                reportDetail.content.abstract.data,
                reportDetail.content.text.data
            ]);
        }
        return false;
    }
    getLang(reportDetail) {
        if (!store.state.isDesktop) return;
        if (reportDetail.content.title || reportDetail.content.abstract || reportDetail.content.text) {
            const countryCode = reportDetail.country[0].code;
            return getVoiceLang(countryCode);
        }
        return false;
    }
    onSpeech(reportDetail) {
        if (!store.state.isDesktop) return;
        const text = this.getTextToSpeech(reportDetail)
        const lang = this.getLang(reportDetail)

        if (store.state.textSpeechIsPaused) {
            this.onResume();
            return;
        }

        if (synth.speaking) {
            this.onCancel();
            return;
        }

        if (!text) {
            return;
        }

        try {
            // cancel current speaking in browser
            this.onCancel();
            synth = window.speechSynthesis;
            if (!synth) console.log('[TextToSpeech] speechSynthesis not available');
            voiceList = synth.getVoices();

            // alert(JSON.stringify(window.speechSynthesis.getVoices()))
            // -----------------------
            textSpeech = new window.SpeechSynthesisUtterance();
            textSpeech.text = text;
            textSpeech.voice = voiceList.filter(v => v.lang === lang)[0];
            // this.textSpeech.pitch = 1.5;
            // use propertie rate to change speak fast or slow
            // console.log(store.state.AppActiveUser);
            console.log('textToSpeech rate: ', store.state.AppActiveUser.rateTextSpeech);
            textSpeech.rate = store.state.AppActiveUser.rateTextSpeech || 1.0;

            textSpeech.onend = () => {
                this.onCancel();
            };
            textSpeech.onerror = (event) => {
                console.error('SpeechSynthesisUtterance.onerror', event);
                this.onCancel();
            };

            store.commit('UPDATE_ISPAUSED_TEXT_SPREECH', false);
            store.commit('UPDATE_ISPLAYING_TEXT_SPREECH', true);
            synth.speak(textSpeech);
            // forceUpdate();
        } catch (error) {
            console.log('[TextToSpeech] ', error);
        }
    }

    onPause() {
        if (!store.state.isDesktop) return;
        try {
            store.commit('UPDATE_ISPAUSED_TEXT_SPREECH', true);
            store.commit('UPDATE_ISPLAYING_TEXT_SPREECH', false);
            synth.pause();
        } catch (error) {
            console.log(error);
        }
    }

    onCancel() {
        if (!store.state.isDesktop) return;
        try {
            store.commit('UPDATE_ISPAUSED_TEXT_SPREECH', false);
            store.commit('UPDATE_ISPLAYING_TEXT_SPREECH', false);
            synth.cancel();
        } catch (error) {
            console.log(error);
        }
    }

    onResume() {
        if (!store.state.isDesktop) return;
        try {
            store.commit('UPDATE_ISPAUSED_TEXT_SPREECH', false);
            store.commit('UPDATE_ISPLAYING_TEXT_SPREECH', true);
            synth.resume();
        } catch (error) {
            console.log(error);
        }
    }
}

export default new TextToSpeech();